import {
  ArrowDown,
  HeartHandshake,
  Import,
  ScanSearch,
  Users,
} from "lucide-react";

import { MarketingContainer } from "./ui/MarketingContainer";

const steps = [
  {
    number: "01",
    title: "Import Members",
    description:
      "Import your existing member records from spreadsheets or another church management system.",
    icon: Import,
  },
  {
    number: "02",
    title: "Track Attendance",
    description:
      "Record attendance and visitor check-ins during every service.",
    icon: Users,
  },
  {
    number: "03",
    title: "Receive Ministry Insights",
    description:
      "MinistryIQ analyzes engagement trends and identifies members who may need follow-up.",
    icon: ScanSearch,
  },
  {
    number: "04",
    title: "Care for Your People",
    description:
      "Take action through guided follow-up and pastoral care recommendations.",
    icon: HeartHandshake,
  },
];

export function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="py-24"
    >
      <MarketingContainer>
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-300">
            How It Works
          </p>

          <h2 className="mt-4 text-4xl font-black text-white sm:text-5xl">
            From attendance to action.
          </h2>

          <p className="mt-6 text-lg text-slate-400">
            Four simple steps to better ministry engagement.
          </p>
        </div>

        <div className="mt-20 grid gap-8 lg:grid-cols-4">
          {steps.map((step, index) => {
            const Icon = step.icon;

            return (
              <div
                key={step.number}
                className="relative text-center"
              >
                <div className="absolute left-1/2 top-0 -translate-x-1/2 text-7xl font-black text-white/5">
                  {step.number}
                </div>

                <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-300">
                  <Icon className="h-7 w-7" />
                </div>

                <h3 className="mt-8 text-xl font-bold text-white">
                  {step.title}
                </h3>

                <p className="mt-3 leading-7 text-slate-400">
                  {step.description}
                </p>

                {index < steps.length - 1 && (
                  <div className="mt-8 hidden justify-center lg:flex">
                    <ArrowDown className="h-6 w-6 text-slate-600" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </MarketingContainer>
    </section>
  );
}